import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=f9ce4702&"
import script from "./FilesTable.vue?vue&type=script&lang=js&"
export * from "./FilesTable.vue?vue&type=script&lang=js&"
import style0 from "./FilesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/studip/studip/studip/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9ce4702')) {
      api.createRecord('f9ce4702', component.options)
    } else {
      api.reload('f9ce4702', component.options)
    }
    module.hot.accept("./FilesTable.vue?vue&type=template&id=f9ce4702&", function () {
      api.rerender('f9ce4702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/FilesTable.vue"
export default component.exports